import { ArrowUpRight } from 'lucide-react'
import { GuideSummary } from '../types/guides'

interface GuideCardProps {
  guide: GuideSummary
}

const GuideCard = ({ guide }: GuideCardProps) => {
  return (
    <article className="border-b border-slate-200 py-6 first:pt-0 last:border-b-0">
      <a href={guide.path} className="group grid gap-5 sm:grid-cols-[minmax(0,1fr)_180px]">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500">
            <span>{guide.category}</span>
            <time dateTime={guide.date}>{guide.date}</time>
          </div>
          <h2 className="mt-2 text-xl font-semibold leading-8 text-slate-950 group-hover:text-slate-600">
            {guide.title}
          </h2>
          <p className="mt-2 line-clamp-2 text-sm leading-6 text-slate-600">{guide.summary}</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-slate-800">
            阅读全文
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </span>
        </div>

        {guide.cover && (
          <div className="aspect-[16/9] overflow-hidden rounded-md bg-slate-100 sm:order-last">
            <img src={guide.cover} alt={guide.title} className="h-full w-full object-cover" loading="lazy" />
          </div>
        )}
      </a>
    </article>
  )
}

export default GuideCard
